export default class ContactSubject {
  constructor(el) {
    this.el = el;

    this.init();
  }

  init() {
    this.premiumMessage = this.el.getAttribute(
      'data-cancel-premium-membership-message'
    );
    this.membershipMessage = this.el.getAttribute(
      'data-cancel-membership-message'
    );
    this.inputFields = this.el.closest('form').querySelectorAll('input');
    this.questionField = this.el
      .closest('form')
      .querySelector('[name=question]');
    this.submitButtons = this.el
      .closest('form')
      .querySelectorAll('button[type=submit]');
    this.alert = document.querySelector('.js-contact-alert');

    this.el.addEventListener('change', this._onChange.bind(this), false);
  }

  _onChange(event) {
    event.preventDefault();

    const { selectedIndex } = event.target.selectedIndex;

    if (selectedIndex === 2 || selectedIndex === 4) {
      this._disableFormFields(true);

      if (selectedIndex === 2) {
        this._showMessage(true, this.premiumMessage);
      } else {
        this._showMessage(true, this.membershipMessage);
      }
    } else {
      this._disableFormFields(false);
      this._showMessage(false);
    }
  }

  _disableFormFields(disable) {
    if (disable) {
      [...this.inputFields].forEach(input => {
        input.classList.add('disabled');
        input.setAttribute('disabled', 'disabled');
      });
      this.questionField.classList.add('disabled');
      this.questionField.setAttribute('disabled', 'disabled');
      [...this.submitButtons].forEach(btn => {
        btn.classList.add('disabled');
        btn.setAttribute('disabled', 'disabled');
      });
    } else {
      [...this.inputFields].forEach(input => {
        input.classList.remove('disabled');
        input.removeAttribute('disabled');
      });
      this.questionField.classList.remove('disabled');
      this.questionField.removeAttribute('disabled');
      [...this.submitButtons].forEach(btn => {
        btn.classList.remove('disabled');
        btn.removeAttribute('disabled');
      });
    }
  }

  _showMessage(show, message) {
    if (show) {
      this.alert.innerHTML = message.trim();
      $(this.alert).fadeIn('slow');
    } else {
      $(this.alert).fadeOut('slow', () => {
        this.alert.innerHTML = '';
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/contact_subject.js